var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGlucoseIconDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.325 17.98a4.335 4.335 0 1 1-8.67 0c0-2.395 4.335-9.001 4.335-9.001s4.335 6.607 4.335 9.001z",
    fill: "#54585A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.255 2.174H9.724a2.333 2.333 0 0 0-2.332 2.333v27.995a2.332 2.332 0 0 0 2.332 2.332h8.282v2.742h4.024v-2.742h8.224a2.333 2.333 0 0 0 2.332-2.332V4.507a2.333 2.333 0 0 0-2.333-2.333zM16.724 32.035h-4.666a1.4 1.4 0 0 1-1.4-1.4V28.77a1.4 1.4 0 0 1 1.4-1.4h4.666a1.4 1.4 0 0 1 1.4 1.4v1.867a1.4 1.4 0 0 1-1.4 1.4zm12.598-1.4a1.4 1.4 0 0 1-1.4 1.4h-4.666a1.4 1.4 0 0 1-1.4-1.4V28.77a1.4 1.4 0 0 1 1.4-1.4h4.666a1.4 1.4 0 0 1 1.4 1.4v1.867zm0-7.465a1.4 1.4 0 0 1-1.4 1.4H12.058a1.4 1.4 0 0 1-1.4-1.4V6.84a1.4 1.4 0 0 1 1.4-1.4h15.864a1.4 1.4 0 0 1 1.4 1.4v16.33z",
    fill: "#54585A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlucoseIconDark);
export default __webpack_public_path__ + "static/media/glucose-icon-dark.d9f1c583.svg";
export { ForwardRef as ReactComponent };